import Call from '../Call';
import {objToQs} from '../Utils';

const BidderQuality = {
    get(filters, path = '') {
        return Call(`bidderQuality/${path}?${objToQs(filters)}`);
    },

    get3(filters, path = '') {
        return Call(`bidderQuality3/${path}?${objToQs(filters)}`);
    }
};

export default BidderQuality;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderQuality.js